import { ChangeDetectionStrategy, HostListener, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Utils } from '../../../../../utils/utils';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { retry, share, switchMap, takeUntil } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Estados } from '../../../../../shared/inmemory-db/estados';
import { ModalidadeFrete } from '../../../../../shared/inmemory-db/modalidade-frete';
import { Estado } from '../../../../../shared/interfaces/estado';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { Log } from '../../../../../shared/interfaces/log';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderProgressService } from '../../../../../shared/services/app-loader-progress/app-loader-progress.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { FatDoctoCUtilsService } from '../../../../../shared/services/fat-docto-c-utils.service';

@Component({
  selector: 'app-lancamento-totais',
  templateUrl: 'lancamento-totais.component.html',
  styleUrls: ['lancamento-totais.component.scss'],
})
export class LancamentoTotaisComponent implements OnInit, OnDestroy {

  public doctoCForm: FormGroup;
  lcto: FatDoctoC;
  doctoIForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  modalidadesFrete: any[];
  estados: Estado[];

  errorMsg: string;

  private stopPolling = new Subject();

  utils = Utils;

  max = null;
  workDone = null;
  it = 0;
  maxRetry = 20;
  created = false;
  disabled: true;
  public layoutConf: any;

  @ViewChild('produtoSearch') produtoSearchInput: ElementRef;

  @HostListener('window:keyup.esc') onKeyUp() {
    if (this.dialog.openDialogs.length > 0) {
      console.log('@HostListener(window:keyup.esc) onKeyUp()');
      this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });     
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoTotaisComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private progressLoader: AppLoaderProgressService,
    private layout: LayoutService
  ) {
    this.modalidadesFrete = new ModalidadeFrete().modalidades;
    this.estados = new Estados().estados;
  }  

  ngOnInit() {
    console.log('INIT TOTAIS');    
    this.layoutConf = this.layout.layoutConf;
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;
  }


  ngOnDestroy() {
    this.stopPolling.next();
  }
  askToSave(){     
    this.confirmService.confirm({ message: `Salvar Lançamento?` })
    .subscribe(res => {
      if (res) {
      }
    });
  } 
    
  private initLogItens() {
    this.it = 0;
    this.workDone = null;
    this.max = null;
  }

  save(previa = false, mostrarOk = true): BehaviorSubject<FatDoctoC> {
    const result = new BehaviorSubject<FatDoctoC>(null);
    const obs = new BehaviorSubject<Log>({} as Log);
    // this.loader.open();
    this.openProgressLoader(obs);
    // this.isSaving$.next(true);
    // this.itemForm.patchValue({ fatListaPrecoTabelaId: this.itemForm['fatListaPrecoTabela'].value?.id?.tabelaId });
    this.doctoCForm.patchValue({ cadastroVendedorId: this.doctoCForm['cadastroVendedorId'] });
    // this.doctoCForm.patchValue({ items: this.doctoIs$.value });
    this.fatDoctoCService.saveOrUpdate(this.doctoCForm.value).subscribe(val => {
      // this.buildDoctoCForm(val);
      console.log(val);
      this.deleteLog();
      if (!previa) {
        if(mostrarOk){
          this.snack.open(`SALVO COM SUCESSO!`, 'OK', { duration: 5500 });
          this.confirmService.confirm({
            title: 'SALVAR',
            message: 'OK, Lançamento Salvo com Sucesso!', error: true
          });
        }
      }
      result.next(val);
      // this.isSaving$.next(false);
      // this.loader.close();
    }, err => {
      // this.loader.close();
      this.deleteLog();
      result.error(err);
      // this.isSaving$.next(false);
      this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
      this.confirmService.confirm({
        title: 'ERRO AO SALVAR, VERIFIQUE',
        message: err.error.status, error: true
      })
    });
    return result;
  }

  fixaPesoBruto() {
    this.doctoCForm.controls['fixaPesoBruto'].patchValue(true);
  }

  fixaPesoLiquido() {
    this.doctoCForm.controls['fixaPesoLiquido'].patchValue(true);
  }

  fixaVolumes() {
    this.doctoCForm.controls['fixaVolumes'].patchValue(true);
  }

  changeDescPerc() {
    const descPerc = this.doctoCForm.controls['descontodoctoPerc'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    if (descPerc === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
    } else if (descPerc <= 100) {
      const descValor = totalProdutos * (descPerc / 100);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(descValor);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: 'Valor desconto: ' + descPerc + ' maior que 100% , VERIFIQUE!', error: true
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      return;
    }
    this.recalcTotal();
  }


  changeDescValor() {
    const descValor = this.doctoCForm.controls['descontodoctoValor'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    if (descValor === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    } else if (descValor <= totalProdutos) {
      const result = ((totalProdutos - (totalProdutos - descValor)) * 100) / totalProdutos;
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(result);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: 'Valor desconto: ' + descValor + ' maior que o Total dos produtos:' + totalProdutos + 'VERIFIQUE!', error: true
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      return;
    }
    this.recalcTotal();
    //     fatDoctoCQueryService.recalcTotais(getFatDoctoCBean(), itemListController.getMasterData());
  }

  recalcTotal() {
    const totalliquidoprodutos = this.doctoCForm.controls['totalliquidoprodutos']?.value || 0;
    const freteValor = this.doctoCForm.controls['freteValor']?.value || 0;
    const despesaValor = this.doctoCForm.controls['despesaValor']?.value || 0;
    const ipiValor = this.doctoCForm.controls['ipiValor']?.value || 0;
    const icmssubstValor = this.doctoCForm.controls['icmssubstValor']?.value || 0;
    const seguroValor = this.doctoCForm.controls['seguroValor']?.value || 0;
    const icmsDesonValor = this.doctoCForm.controls['icmsDesonValor']?.value || 0;
    const descontodoctoValor = this.doctoCForm.controls['descontodoctoValor']?.value || 0;

    this.doctoCForm.controls['valortotalDocto'].patchValue(totalliquidoprodutos + freteValor
      + despesaValor + ipiValor + icmssubstValor + seguroValor - icmsDesonValor - descontodoctoValor);
  }

  submit() {
    if (this.doctoCForm.valid) {
      console.log('form submitted');
      // this.dialogRef.close(this.itemForm.value)
    } else {
      this.validateAllFormFields(this.doctoCForm); // {7}
    }
  }

  /** UTILS */
  private deleteLog() {
    this.fatDoctoCService.deleteLog(this.lcto?.uuid).subscribe((log) => {
      this.progressLoader.close();
    });
  }

  private openProgressLoader(obs: BehaviorSubject<Log>) {
    this.progressLoader.open(obs);
    timer(1, 1500).pipe(
      switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
      retry(),
      share(),
      takeUntil(this.stopPolling)
    ).subscribe(valor => {
      if (this.max === valor.max && this.workDone === valor.workDone) {
        this.it = this.it + 1;
      } else {
        this.it = 0;
      }
      this.max = valor.max;
      this.workDone = valor.workDone;
      if ((valor.workDone !== null && valor.workDone !== undefined
        && valor.max != null && valor.max !== undefined
        && valor.workDone >= valor.max) || this.it === this.maxRetry) {
        this.stopPolling.next();
        this.initLogItens();
      }
      obs.next(valor);
    }, err => {
      this.loader.close();
      this.confirmService.confirm({
        title: 'ERRO AO EXECUTAR OPERAÇÃO',
        message: err.error.status, error: true
      });
    });
  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  isFieldValid(field: string) {
    return !this.doctoCForm.get(field).valid && this.doctoCForm.get(field).touched;
  }

  close() {
    this.dialogRef.close();
  }

}
